import React, { useRef, useEffect } from 'react';
import { Button } from '@components/ui';
import { Send } from 'lucide-react';
import Textarea from 'react-textarea-autosize';
import { cn } from '../../../../../lib/utils';

interface ChatInputProps {
  input: string;
  handleInputChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  handleSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  isLoading: boolean;
  placeholder?: string;
}

export const ChatInput: React.FC<ChatInputProps> = ({
  input,
  handleInputChange,
  handleSubmit,
  isLoading,
  placeholder = 'Ask me anything about this content...',
}) => {
  const inputRef = useRef<HTMLTextAreaElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
  }, []);

  return (
    <form onSubmit={handleSubmit} className="relative w-full">
      <Textarea
        ref={inputRef}
        rows={1}
        maxRows={5}
        autoFocus
        value={input}
        onChange={handleInputChange}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSubmit(e as any);
          }
        }}
        placeholder={placeholder}
        className="w-full resize-none rounded-full border !border-gray-300 !bg-gray-100 py-3 !pl-6 !pr-14 text-sm focus:!outline-none focus:!border-gray-300 focus:!bg-white focus:!text-black"
      />
      <Button
        type="submit"
        size="icon"
        disabled={isLoading || !input.trim()}
        className={cn(
          'absolute !right-2 !top-1 !rounded-full border-none outline-none !bg-sky-500 !text-white hover:!bg-sky-600 disabled:!bg-sky-500 disabled:!text-white',
          isLoading && 'animate-pulse'
        )}
      >
        <Send className="h-5 w-5" />
      </Button>
    </form>
  );
};
